import Component from '@glimmer/component';

export default class VisitorsAnalyticsUpsellBannerComponent extends Component {
  get ctaId() {
    return this.args.global ? 'analytics_visitors_global_upgrade' : 'analytics_visitors_upgrade';
  }
}
